'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = exports.Thead = exports.Tbody = exports.Tr = exports.Th = exports.Td = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  padding: ', ' ', ' ', ';\n  font-size: ', ';\n  font-family: ', ';\n  text-align: left;\n  ', ';\n'], ['\n  padding: ', ' ', ' ', ';\n  font-size: ', ';\n  font-family: ', ';\n  text-align: left;\n  ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n        &:first-child {\n          position: relative;\n          &:before {\n            content: \'\';\n            width: ', ';\n            height: 100%;\n            position: absolute;\n            left: 0;\n            top: 0;\n            bottom: 0;\n            background-color: ', ';\n          }\n        }\n      '], ['\n        &:first-child {\n          position: relative;\n          &:before {\n            content: \'\';\n            width: ', ';\n            height: 100%;\n            position: absolute;\n            left: 0;\n            top: 0;\n            bottom: 0;\n            background-color: ', ';\n          }\n        }\n      ']),
    _templateObject3 = _taggedTemplateLiteral(['\n  padding: 0 ', ' ', ';\n  font-size: ', ';\n  text-align: left;\n  ', ';\n  font-weight: bold;\n  color: ', ';\n'], ['\n  padding: 0 ', ' ', ';\n  font-size: ', ';\n  text-align: left;\n  ', ';\n  font-weight: bold;\n  color: ', ';\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  transition: background 0.3s ease;\n  ', ';\n  ', ';\n'], ['\n  transition: background 0.3s ease;\n  ', ';\n  ', ';\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n        &:hover > td {\n          background: ', ';\n        }\n      '], ['\n        &:hover > td {\n          background: ', ';\n        }\n      ']),
    _templateObject6 = _taggedTemplateLiteral(['\n        ', ' {\n          background: ', ';\n          color: ', ';\n        }\n      '], ['\n        ', ' {\n          background: ', ';\n          color: ', ';\n        }\n      ']),
    _templateObject7 = _taggedTemplateLiteral(['\n  ', ';\n'], ['\n  ', ';\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n        & > :nth-child(odd) {\n          background-color: ', ';\n        }\n      '], ['\n        & > :nth-child(odd) {\n          background-color: ', ';\n        }\n      ']),
    _templateObject9 = _taggedTemplateLiteral(['\n        ', ' {\n          position: relative;\n        }\n        th + th:before {\n          content: \'\';\n          width: ', ';\n          background-color: ', ';\n          position: absolute;\n          left: 0;\n          top: ', ';\n          bottom: ', ';\n        }\n      '], ['\n        ', ' {\n          position: relative;\n        }\n        th + th:before {\n          content: \'\';\n          width: ', ';\n          background-color: ', ';\n          position: absolute;\n          left: 0;\n          top: ', ';\n          bottom: ', ';\n        }\n      ']),
    _templateObject10 = _taggedTemplateLiteral(['\n  width: 100%;\n  font-family: ', ';\n  border-collapse: collapse;\n  border-spacing: 0;\n  background: ', ';\n  line-height: ', ';\n\n  ', ';\n'], ['\n  width: 100%;\n  font-family: ', ';\n  border-collapse: collapse;\n  border-spacing: 0;\n  background: ', ';\n  line-height: ', ';\n\n  ', ';\n']),
    _templateObject11 = _taggedTemplateLiteral(['\n        font-size: ', ';\n        ', ';\n        ', ' {\n          border-top: ', ' solid\n            ', ';\n          border-bottom: ', ' solid\n            ', ';\n        }\n        ', ';\n      '], ['\n        font-size: ', ';\n        ', ';\n        ', ' {\n          border-top: ', ' solid\n            ', ';\n          border-bottom: ', ' solid\n            ', ';\n        }\n        ', ';\n      ']),
    _templateObject12 = _taggedTemplateLiteral(['\n          font-size: ', ';\n        '], ['\n          font-size: ', ';\n        ']),
    _templateObject13 = _taggedTemplateLiteral(['\n          ', ' {\n            padding: ', ' ', ';\n          }\n        '], ['\n          ', ' {\n            padding: ', ' ', ';\n          }\n        ']),
    _templateObject14 = _taggedTemplateLiteral([''], ['']);

var _polished = require('polished');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Td = exports.Td = _styledComponents2.default.td(_templateObject, (0, _polished.rem)(4), (0, _polished.rem)(10), (0, _polished.rem)(2), function (_ref) {
  var theme = _ref.theme;
  return theme.font.fontSizeXS;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.font.fontFamily;
}, function (props) {
  if (props.center) {
    return 'text-align: center;';
  }
  if (props.right) {
    return 'text-align: right;';
  }
  if (props.colorLabel) {
    return (0, _styledComponents.css)(_templateObject2, (0, _polished.rem)(5), props.colorLabel);
  }
  if (props.flag) {
    return '\n        position: relative;\n        overflow: hidden;\n        &:before {\n          content: "";\n          position: absolute;\n          width: ' + (0, _polished.rem)(35) + ';\n          height: ' + (0, _polished.rem)(10) + ';\n          left: -' + (0, _polished.rem)(9) + ';\n          top: 0;\n          transform: rotate(-45deg);\n          background-color: ' + props.flag + ';\n        }\n      ';
  }
  return '';
});

var Th = exports.Th = _styledComponents2.default.th(_templateObject3, (0, _polished.rem)(10), (0, _polished.rem)(5), function (_ref3) {
  var theme = _ref3.theme;
  return theme.font.fontSizeXS;
}, function (props) {
  if (props.center) {
    return 'text-align: center;';
  }
  if (props.right) {
    return 'text-align: right;';
  }
  return '';
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.color.textColor;
});

var Tr = exports.Tr = _styledComponents2.default.tr(_templateObject4, function (props) {
  if (props.rowHover) {
    return (0, _styledComponents.css)(_templateObject5, function (_ref5) {
      var theme = _ref5.theme;
      return theme.table.hover;
    });
  }
  return '';
}, function (props) {
  if (props.disabled) {
    return (0, _styledComponents.css)(_templateObject6, Td, function (_ref6) {
      var theme = _ref6.theme;
      return theme.table.inactiveColor;
    }, function (_ref7) {
      var theme = _ref7.theme;
      return theme.table.inactiveTextColor;
    });
  }
  return '';
});

var Tbody = exports.Tbody = _styledComponents2.default.tbody(_templateObject7, function (props) {
  if (!props.strip) {
    return (0, _styledComponents.css)(_templateObject8, function (_ref8) {
      var theme = _ref8.theme;
      return theme.table.oddRowBg;
    });
  }
  return '';
});

var Thead = exports.Thead = _styledComponents2.default.thead(_templateObject7, function (props) {
  if (props.thSorter) {
    return (0, _styledComponents.css)(_templateObject9, Th, (0, _polished.rem)(1), function (_ref9) {
      var theme = _ref9.theme;
      return theme.table.thSeparatorColor;
    }, (0, _polished.rem)(5), (0, _polished.rem)(5));
  }
  return '';
});

var Table = exports.Table = _styledComponents2.default.table(_templateObject10, function (_ref10) {
  var theme = _ref10.theme;
  return theme.font.fontFamily;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.table.tableBg;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.lineHeight;
}, function (props) {
  if (props.tableSorter) {
    return (0, _styledComponents.css)(_templateObject11, function (_ref13) {
      var theme = _ref13.theme;
      return theme.font.fontSizeXS;
    }, function (_ref14) {
      var theme = _ref14.theme;
      return theme.media.m(_templateObject12, theme.font.fontSizeS);
    }, Tbody, (0, _polished.rem)(1), function (_ref15) {
      var theme = _ref15.theme;
      return theme.table.separatorColor;
    }, (0, _polished.rem)(2), function (_ref16) {
      var theme = _ref16.theme;
      return theme.table.separatorColor;
    }, function (_ref17) {
      var theme = _ref17.theme;
      return theme.media.l(_templateObject13, (Th, Td), (0, _polished.rem)(5), (0, _polished.rem)(15));
    });
  }

  return (0, _styledComponents.css)(_templateObject14);
});

exports.default = { Table: Table, Tbody: Tbody, Thead: Thead, Tr: Tr, Th: Th, Td: Td };


//////////////////
// WEBPACK FOOTER
// ./node_modules/oxyrion-ui/lib/Table/index.js
// module id = 63
// module chunks = 1